import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { NzUploadChangeParam, NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { ConfigService } from '../../../services/config.service';
import { Login } from '../../../login/login';

/* nzUpload: Upload */
import { BrowserModule, DomSanitizer } from '@angular/platform-browser'
/* nzUpload: Custom pre-upload checks */
import { /*Observable,*/ Observer } from 'rxjs';
/* nzUpload: Custom Upload request */
import { HttpRequest, HttpClient, HttpEventType, HttpEvent, HttpResponse } from '@angular/common/http';

import { NzMessageService } from 'ng-zorro-antd/message';
import { MedicamentoService } from '../../../services/medicamento.service';

function getBase64(file: File): Promise<string | ArrayBuffer | null> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

function b64toArrayBuffer(dataURI) {
  const byteString = atob(dataURI.split(',')[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return ia;
}

@Component({
    selector: 'app-importacao-excel',
    templateUrl: './importacao-excel.component.html',
    styleUrls: ['./importacao-excel.component.css'],
    standalone: false
})
export class ImportacaoExcelComponent implements OnInit, OnChanges {

  atual = 0;
  url = '';
  token;
  limiteColunas: any = 11;
  idarquivo = null;
  fileList: NzUploadFile[] = [];
  buttonProximoDisable = true;
  criar_atualizar = false;
  ignorar_primeira_linha = true;
  inativar_prod_inexistente = true;
  disableButtonAddColunas = false;
  
  loading = false;
  loadingDownloadPlanilha = false; //Usado no download de planilha de exemplo
  @Output() eventCloseModal = new EventEmitter<any>(); //Disparado quando se cadastra um compra

  tipos = [
    {
      descricao: 'Cod. de Barras',
      key: 'ean',
      habilitado: 1,
      coluna: null
    },
    {
      descricao: 'Descrição',
      key: 'descricao',
      habilitado: 1,
      coluna: null
    },
    {
      descricao: 'Autorizador',
      key: 'autorizador',
      habilitado: 1,
      coluna: null
    },
    {
      descricao: 'Programa',
      key: 'programa',
      habilitado: 1,
      coluna: null
    },
    {
      descricao: 'Medicamento Controlado',
      key: 'controlado',
      habilitado: 1,
      coluna: null
    },
    {
      descricao: 'Laboratório',
      key: 'laboratorio',
      habilitado: 1,
      coluna: null
    },
    {
      descricao: 'Desconto',
      key: 'desconto',
      habilitado: 1,
      coluna: null
    },
    {
      descricao: 'Obs. Desconto',
      key: 'obs_desconto',
      habilitado: 1,
      coluna: null
    },
    {
      descricao: 'Tel. Programa',
      key: 'tel_programa',
      habilitado: 1,
      coluna: null
    },
    {
      descricao: 'Site',
      key: 'site',
      habilitado: 1,
      coluna: null
    },
    {
      descricao: 'Principio Ativo 01',
      key: 'principio_ativo_1',
      habilitado: 1,
      coluna: null
    },
    {
      descricao: 'Principio Ativo 02',
      key: 'principio_ativo_2',
      habilitado: 1,
      coluna: null
    },
    {
      descricao: 'Principio Ativo 03',
      key: 'principio_ativo_3',
      habilitado: 1,
      coluna: null
    }
  ];
  backupColunas: any = {};
  colunas: any = {
    'a1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).a1,
    'b1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).b1,
    'c1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).c1,
    'd1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).d1,
    'e1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).e1,
    'f1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).f1,
    'g1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).g1,
    'h1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).h1,
    'i1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).i1,
    'j1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).j1,
    'k1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).k1,
    'l1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).l1,
    'm1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).m1,
    'n1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).n1,
    'o1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).o1,
    'p1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).p1,
    'q1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).q1,
    'r1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).r1,
    's1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).s1,
    't1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).t1,
    'u1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).u1,
    'v1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).v1,
    'w1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).w1,
    'x1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).x1,
    'y1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).y1,
    'z1': localStorage.getItem('colunasMedicamento') === null ? null : JSON.parse(localStorage.getItem('colunasMedicamento')).z1,
  };

  constructor(
    private msg: NzMessageService,
    private http: HttpClient,
    private configService: ConfigService,
    private medicamentoService: MedicamentoService
  ) {
    this.url = configService.getURL() + 'medicamento/importar/xlsx';
    let token = new Login;
    this.token = 'Bearer ' + token.getToken();
    this.backupColunas = this.colunas;
  }

  ngOnInit(): void {
    this.mostrarMaisColuna();
    this.alteracaoTipo('');

    for (let index = 0; index <= parseInt(localStorage.getItem('limitColunasMedicamento')); index++) {
      if (index > this.limiteColunas) {
        this.mostrarMaisColuna();
      }
    }

  }

  ngOnChanges() {

  }
  pre(): void {
    this.atual -= 1;
  }

  next(): void {
    this.buttonProximoDisable = true;
    this.loading = true;

    if (this.atual === 1) {
      var colunasTipo = [];
      this.tipos.forEach(function (tipo) {
        colunasTipo[tipo.key] = tipo.coluna;
      });
      localStorage.setItem('colunasMedicamento', JSON.stringify(this.colunas));
      localStorage.setItem('limitColunasMedicamento', this.limiteColunas);

      this.medicamentoService.mapearColunas(this.idarquivo, this.tipos).subscribe((c: any) => {
        this.loading = false;
        this.atual += 1;
      });
    } else if (this.atual === 0) {
      this.alteracaoTipo('');
      this.atual += 1;
      this.loading = false;
    } else {
      this.atual += 1;
      this.loading = false;

    }
  }

  done(): void {
    this.atual = 0;
    this.eventCloseModal.emit(true);
  }

  mostrarMaisColuna() {
    this.limiteColunas = this.limiteColunas + 1;

    let keys = Object.keys(this.colunas);
    const tempColunas = {};
    var contador = 0;
    Object.entries(this.backupColunas).forEach(([k, v]) => {
      if (contador <= this.limiteColunas) {
        if (this.colunas[k]) {
          tempColunas[k] = this.colunas[k];
        } else {
          tempColunas[k] = this.backupColunas[k];
        }

      }
      contador = contador + 1;
    });
    if (this.limiteColunas > contador) {
      this.disableButtonAddColunas = true;
    }
    this.colunas = tempColunas;
  }

  alteracaoTipo(event) {

    this.tipos.forEach((value, index) => {
      var i = 0;
      this.tipos[index]['habilitado'] = 1;
      this.tipos[index]['coluna'] = null;

      Object.entries(this.colunas).forEach(([k, v]) => {

        if (value['key'] === v) {
          localStorage.setItem('xlsx_medicamento_' + k, this.colunas[k]);
          this.colunas[k] = value['key'];
          this.tipos[index]['habilitado'] = 0;
          this.tipos[index]['coluna'] = i;

        }
        i += 1;
      });

      var habilitados = 0;
      this.tipos.forEach(function (e) {
        if (e.habilitado === 1) {
          habilitados++;
        }
      });
      //Habilita ou não o botao de proximo
      if (habilitados === 0) {
        this.buttonProximoDisable = false;
      } else {
        this.buttonProximoDisable = true;
      }
    });

  }
  setMediaUploadHeaders = (file: any) => {
    return {
      "Content-Type": "multipart/form-data",
      "Accept": "application/json",
      "Authorization": this.token
    }

  };

  upload = (file: File, item: NzUploadXHRArgs) => {
    var hi = getBase64(file['file']!);
    this.loading = true;
    hi.then((result) => {
      b64toArrayBuffer(result);
      let base64 = (<string>result).replace("data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,", "");
 
      this.medicamentoService.uploadXLSX(base64, this.criar_atualizar, file['file']['name'], this.ignorar_primeira_linha, this.inativar_prod_inexistente).subscribe((u: any) => {
        this.buttonProximoDisable = false;
        this.loading = false;
        this.idarquivo = u.data.idarquivo;
        //this.msg.success('Tudo certo! clique em Próximo para continuar.');
        this.next();

      });
    });
  }

  handleChange(event) {
    event.file.status = 'done';
  }

  downloadPlaninhaExemplo(){
    this.loadingDownloadPlanilha = true;
    this.medicamentoService.downloadPlanilhaExemplo().subscribe((d: any) => {
      this.loadingDownloadPlanilha = false;
      let blob = new Blob([d], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});

      var downloadURL = window.URL.createObjectURL(d);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "Planilha_medicamentos_exemplo.xlsx";
      link.click();
    });
  }
}